'use strict';

class BasicController {
    /*@ngInject*/
    constructor ($scope, $stateParams, $state, orderStore, $q, utils, auth) {
        "ngInject";
        _.extend(this, {
            $scope: $scope,
            $stateParams: $stateParams,
            $state: $state,
            $q: $q,
            orderStore: orderStore,
            utils: utils,
            auth: auth
        });
        this.orderLoader = this.orderStore.getOrderWithRedirectionCheck($stateParams.orderId)
            .then(
                (order) => {
                    this.order = order;

                    // The auto complete widget does not like undefined properties
                    if (this.order.to_address.place_id) {
                        this.to = this.order.to_address;
                    }

                    if (this.order.from_address.place_id) {
                        this.from = this.order.from_address;
                    }

                    [this.minMoveDate, this.formattedMinMoveDate] = this.utils.getMinMoveDate();
                    [this.maxMoveDate, this.formattedMaxMoveDate] = this.utils.getMaxMoveDate();
                    this.moveDate = this.utils.getDefaultMoveDate();
                },
                (error) => this.$q.reject(error)
            );

        /**
         * Custom validation for selecting a predefined locality provided by google places
         */
        this.showTabHelpText = true;


        this.$scope.$watch(
            () => this.fromLocalitySearchText,
            () => this.setFromToValidity(this.from, 'fromLocality')
        );

        this.$scope.$watch(
            () => this.toLocalitySearchText,
            () => this.setFromToValidity(this.to, 'toLocality')
        );

        this.$scope.$watch(
            () => this.basicForm,
            () => {
                this.setFromToValidity(this.from, 'fromLocality');
                this.setFromToValidity(this.to, 'toLocality');
            }
        );
    }

    houseTypes = [
        {displayName: '1 BHK', value: '1 BHK'},
        {displayName: '2 BHK', value: '2 BHK'},
        {displayName: '3 BHK', value: '3 BHK'},
        {displayName: '3+ BHK', value: '3+ BHK'},
        {displayName: 'duplex villa', value: 'DUPLEX_VILLA'},
        {displayName: 'vehicle', value: 'VEHICLE'},
        {displayName: 'few items', value: 'FEW_ITEMS'}
    ]

    findLocality (searchText) {
        if (_.isEmpty(searchText)) {
            return undefined;
        }
        let deferred = this.$q.defer();
        piko.googlePlaces.getPlacePredictions({
            input: searchText,
            componentRestrictions: {country: 'in'}
        }, function (data) {
            deferred.resolve(data);
        });
        return deferred.promise;
    }

    getAddressDetailsFor (placeIds) {
        let requests = _.map(placeIds, (placeId) => {
            let request = this.$q.defer();
            piko.googlePlaceDetails.getDetails({placeId: placeId}, (details) =>
                request.resolve({details: details, placeId: placeId})
            );
            return request.promise;
        });

        return this.$q.all(requests);
    }
    enterKey(keyEvent) {
        if (keyEvent.which == 13 || keyEvent.keyCode == 13) {
            this.next();
        }
  }

    getLatLongFrom (placeDetails) {
        return {
            latitude: placeDetails.geometry.location.lat(),
            longitude: placeDetails.geometry.location.lng()
        }
    }

    determineMoveType() {
        if (_.isUndefined(this.from.place_id) || _.isUndefined(this.to.place_id)) {
            return this.$q.reject();
        }

        let knownCitiesPromise = this.utils.fetchAllCities(),
            selectedAddressDetailsPromise = this.getAddressDetailsFor([this.from.place_id, this.to.place_id]);

        let deferred = this.$q.all([knownCitiesPromise, selectedAddressDetailsPromise])
            .then((resolved) => {
                let [cities, addressDetails] = resolved;
                return [
                    cities,
                    _.map(addressDetails, (detail) => this.getLatLongFrom(detail.details))
                ];
            })
            .then((resolved) => {
                let [knownCities, locations] = resolved;
                return _.map(locations, (location) => this.cityOf(location, knownCities));
            })
            .then((cities) => this.determineMoveTypeFromCities(cities));


        this.utils.busyDeferred(this, deferred, '__busy');

        return deferred;
    }

    cityOf(location, knownCities) {
        let [x, y] = [location.latitude, location.longitude];
        return _.find(knownCities, (city) => {
            let [x0, y0] = [city.latitude_point_one, city.longitude_point_one],
                [x1, y1] = [city.latitude_point_two, city.longitude_point_two];
            return (x > x0 && x < x1) && (y > y0 && y < y1);
        });
    }

    determineMoveTypeFromCities(cities) {
        const INTERCITY = 'intercity', LOCAL = 'local';
        let [from, to] = cities;

        if (_.isUndefined(from)) {
            return INTERCITY;
        }

        if (from && _.isUndefined(to)) {
            return INTERCITY;
        }

        if (from.id === to.id) {
            return LOCAL;
        }

        return INTERCITY;
    }

    checkIfValidForm() {
        const form = this.basicForm;

        // Set form as submitted
        form.$setSubmitted();

        return form.$valid;
    }

    setFromToValidity(location, elementName) {
        const placeId = location && location.place_id;
        const isValid = !!placeId;

        if (this.basicForm && this.basicForm[elementName]) {
            this.basicForm[elementName].$setValidity('pkRequired', isValid);
        }
    }

    next() {

        const isValidForm = this.checkIfValidForm();
        if (!isValidForm) {
            return false;
        }

        this.orderLoader = this.determineMoveType()
            .then(
                (moveType) => {
                    this.order.move_type = moveType;
                    return this.getAddressDetailsFor([this.from.place_id, this.to.place_id]);
                },
                (error) => {
                    this.orderLoader = undefined;
                    return this.$q.reject(error);
                }
            )
            .then(
                (details) => {
                    _.forEach(details, (detail, index) => {
                        let keyToUpdate = index === 0 ? 'from_address' : 'to_address',
                            addressLocality = (index === 0 ? this.from.description : this.to.description) || this.order[keyToUpdate].name;
                        _.extend(
                            this.order[keyToUpdate],
                            this.getLatLongFrom(detail.details), {place_id: detail.placeId},
                            {name: addressLocality}
                        );
                    });
                    this.order.order_time = parseInt(this.moveDate.getTime() / 1000, 10);
                    this.orderStore.saveOrder(this.order)
                        .then((order) => {
                            let nextState;

                            if (order.property_type.toLowerCase() === 'vehicle') {
                                if (this.auth.isAuthenticated() || (this.auth.isAdminUser() && this.order.user_id)) {
                                    nextState = this.utils.getAdminStateIfApplicable('base.home');
                                    return this.$state.go(nextState, {orderId: order.id});
                                } else {
                                    nextState = this.utils.getAdminStateIfApplicable('base.login');
                                    let redirectState = this.utils.getAdminStateIfApplicable('base.home');
                                    return this.$state.go(nextState, {orderId: this.order.id, redirect: redirectState, showSavePopup: false});
                                }

                            }

                            // Should the temporary storage page be shown?
                            const INTERCITY = 'intercity', LOCAL = 'local';
                            switch (this.order.move_type) {
                                case INTERCITY:
                                    nextState = this.utils.getAdminStateIfApplicable('base.floor');
                                    this.$state.go(nextState, {orderId: order.id});
                                    break;
                                case LOCAL:
                                    nextState = this.utils.getAdminStateIfApplicable('base.floor');
                                    this.$state.go(nextState, {orderId: order.id});
                                    break;
                                default:
                                    throw new Error('Unknown move type for order. Cannot proceed');
                            }
                        });
                }
            );
    }
}

BasicController.bindings = {};


export default BasicController;


// WEBPACK FOOTER //
// ./client/app/components/basic/basic.controller.js